import { createRef, useCallback, useContext, useEffect, useRef, useState } from "react"
import { useStyles } from "./styles"
import { TourCanvasElement, TourCanvasProps, TourContextType } from "../tour.typings"
import { TourContext } from "../tourContext"

const TourCanvas: React.FC<TourCanvasProps> = ({elements}) => {
    const {classes} = useStyles()
    const tourContext = useContext(TourContext)
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const previousElements = useRef<TourCanvasElement[]>([])
    const { transitionDuration } = tourContext.displayStyles

    const render = useCallback((els: TourCanvasElement[] = [], tourCtx: TourContextType) => {
        // const prevElements = previousElements.current
        // if (prevElements.map(v => v.selector).sort().join("") === els.map(v => v.selector).sort().join("")) {
        //     console.log("tour: previous elements same")
        //     return;
        // }

        const {current: canvas} = canvasRef;
        if (!canvas) return;
        const {width, height, devicePixelRatio} = tourCtx
        const context = canvas.getContext("2d")
        if (!context) return;
        previousElements.current = els;
        canvas.width = width*devicePixelRatio;
        canvas.height = height*devicePixelRatio;
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";
        context.scale(devicePixelRatio, devicePixelRatio)

        const {displayStyles: {padding, cornerRadius, borderWidth, borderColor}} = tourContext;

        requestAnimationFrame(() => {
            console.log("tour: rendering")
            context.clearRect(0, 0, context.canvas.width, context.canvas.height);

            context.fillStyle = "#000";
            context.globalAlpha = 0.7;
            context.beginPath();
            context.lineTo(0,context.canvas.height)
            context.lineTo(context.canvas.width,context.canvas.height)
            context.lineTo(context.canvas.width, 0,)
            context.lineTo(0,0)
            els.forEach(({coordinates, padding: elePadding}) => {

                const {topLeft, topRight, bottomLeft, } = coordinates;
                context.roundRect(topLeft.x - (elePadding || padding || 0) + borderWidth, topLeft.y - (elePadding || padding || 0) + borderWidth, topRight.x - topLeft.x + 2*(elePadding || padding || 0) - 2*borderWidth, bottomLeft.y - topLeft.y + 2*(elePadding || padding || 0) - 2*borderWidth, cornerRadius )
            })
            context.clip()
            context.fillRect(0, 0, context.canvas.width, context.canvas.height);

            els.forEach(({coordinates}) => {
                context.beginPath()
                const {topLeft, topRight, bottomLeft, } = coordinates;
                context.roundRect(topLeft.x - padding, topLeft.y - padding, topRight.x - topLeft.x + 2*padding, bottomLeft.y - topLeft.y + 2*padding, cornerRadius )
                context.closePath();
                context.globalAlpha = 1;
                context.strokeStyle = borderColor;
                context.lineWidth = borderWidth;
                context.stroke()
            })
        })
    }, [])

    useEffect(() => {
        elements.length && tourContext && canvasRef.current && render(elements, tourContext)
    }, [elements, tourContext])
    // useEffect(() => {
    //     const {current: canvas} = canvasRef;
    //     if (!canvas) return;
    //     const ctx = canvas.getContext("2d")
    //     if (!ctx) return;
    //     const width = canvas.clientWidth;
    //     const height = canvas.clientHeight;
    //     // ctx.scale(devicePixelRatio, devicePixelRatio)
    //     console.log("tour:", canvasRef.current)
    //     //@ts-ignore
    //     window.ctx = ctx;
    //     canvas.width = width*devicePixelRatio;
    //     canvas.height = height*devicePixelRatio;
    //     canvas.style.width = width + "px";
    //     canvas.style.height = height + "px";
    //     ctx.fillStyle = "#444";
    //     ctx.beginPath();
    //     ctx.rect(50,50, 200, 200)
    //     ctx.moveTo(70, 70)
    //     ctx.lineTo(70, 90)
    //     ctx.lineTo(90, 90)
    //     ctx.lineTo(90, 70)
    //     ctx.lineTo(70, 70)

    //     ctx.moveTo(100, 100)
    //     ctx.lineTo(100, 120)
    //     ctx.lineTo(120, 120)
    //     ctx.lineTo(120, 100)
    //     ctx.lineTo(100, 100)


    //     ctx.clip()
    //     ctx.globalAlpha = 0.5
    //     ctx.fillRect(50,50, 200, 200)
    // }, [])
    return  <canvas ref={canvasRef} className={classes.tourCanvas}></canvas>
}

export default TourCanvas